<div class="error-container">
    <h2>An Error Occurred</h2>
    <p>We ran into an error, please use KMT source documents. Please also check with your supervisor to see if an IT ticket is needed.</p>
</div>